const padId = (id) => String(id).padStart(3, '0');

const formatPrefixedId = (prefix, id) => {
    if (id == null || id === '' || id === 'N/A') return id;
    const num = Number(id);
    if (Number.isNaN(num)) return id;
    return `${prefix}-${padId(id)}`;
};

export const formatCarePlanId = (id) => formatPrefixedId('P', id);

export const formatQuotationId = (id) => formatPrefixedId('Q', id);

/** Display date for Created headers (e.g. 3 Aug 2026). */
export const formatCreatedDate = (value) => {
    if (!value) return '—';
    const raw = String(value).trim();
    const dayMatch = raw.match(/^(\d{4}-\d{2}-\d{2})/);
    const date = dayMatch
        ? new Date(`${dayMatch[1]}T12:00:00`)
        : new Date(raw);
    if (Number.isNaN(date.getTime())) return raw;
    return date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });
};
